

import { ProjectModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { projectsStore } from '@/libs/projects/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import ProjectDialog from '../components/ProjectDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        ProjectDialog
    }
})
export default class Projects extends Page {

    get headers() {
        return [
            { text: this.$i18n.t("projects.code"), value: "code", align: "left", sortable: false },
            { text: this.$i18n.t("projects.name"), value: "name", align: "left", sortable: false },
            { text: "", value: "id", align: "left", sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: ProjectDialog;

    @Watch("itemsPerPage")
    itemsPerPageChanged (v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return projectsStore.useGetter(CrudGetter.Pending);
    }
    
    get categories (): ProjectModel[] {
        return [...projectsStore.useGetter(CrudGetter.Data)];
    }

    get totalRows (): number {
        return ({...projectsStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

    mounted () {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load () {
        projectsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<ProjectModel>({ field: "name", index: 1, order: "asc" }, this.getFilters());
    }

    open (item: ProjectModel) {
        this.dialog.open(item.id!);
    }

    createItemClick () {
        this.dialog.open(Guid.EmptyGuid());
    }

}
